import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { for: "email" }
const _hoisted_2 = { for: "password" }
const _hoisted_3 = { for: "entity_type" }
const _hoisted_4 = {
  key: 1,
  class: "login_actions"
}
const _hoisted_5 = {
  key: 0,
  class: "register_container"
}
const _hoisted_6 = { class: "tutorial_iframe_wrapper" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_LoginContainer = _resolveComponent("LoginContainer")!

  return (_openBlock(), _createBlock(_component_LoginContainer, { isLoading: _ctx.isLoading }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        _createVNode(_component_FloatLabel, null, {
          default: _withCtx(() => [
            _createVNode(_component_InputText, {
              id: "email",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
              fluid: "",
              type: "email",
              required: ""
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t('login_view.view.email_label')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_FloatLabel, null, {
          default: _withCtx(() => [
            _createVNode(_component_Password, {
              id: "password",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
              fluid: "",
              feedback: false,
              required: ""
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('login_view.view.password_label')), 1)
          ]),
          _: 1
        }),
        (_ctx.entityType != 'admin')
          ? (_openBlock(), _createBlock(_component_FloatLabel, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_Select, {
                  id: "entity_type",
                  options: _ctx.entityTypeOptions,
                  optionLabel: _ctx.getEntityTypeLabel,
                  "onUpdate:modelValue": [
                    _ctx.entityChange,
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entityType) = $event))
                  ],
                  modelValue: _ctx.entityType,
                  fluid: ""
                }, null, 8, ["options", "optionLabel", "onUpdate:modelValue", "modelValue"]),
                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('login_view.view.entity_type_label')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          label: _ctx.$t('login_view.view.login_button'),
          fluid: "",
          type: "submit"
        }, null, 8, ["label"]),
        (_ctx.entityType != 'admin')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_RouterLink, {
                id: "forgot_btn",
                to: {name: 'password_reset'}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    label: _ctx.$t('login_view.view.forgot_password'),
                    fluid: "",
                    severity: "info",
                    outlined: "",
                    icon: "pi pi-question-circle"
                  }, null, 8, ["label"])
                ]),
                _: 1
              }),
              (_ctx.tutorialVideoUrl)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "tutorial_btn",
                    type: "button",
                    label: _ctx.$t('login_view.view.tutorial_button'),
                    fluid: "",
                    severity: "secondary",
                    icon: "pi pi-video",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tutorialDialogVisible = true))
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 32),
      (_ctx.entityType != 'admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('login_view.view.no_account_txt')), 1),
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('login_view.view.no_account_txt_create_info')), 1),
            _createVNode(_component_RouterLink, { to: {name: 'password_reset', params: { create: '1' }} }, {
              default: _withCtx(() => [
                _createVNode(_component_Button, {
                  label: _ctx.$t('login_view.view.create_password_button'),
                  fluid: "",
                  style: {"margin-bottom":"1rem"}
                }, null, 8, ["label"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.tutorialVideoUrl && _ctx.entityType != 'admin')
        ? (_openBlock(), _createBlock(_component_Dialog, {
            key: 1,
            visible: _ctx.tutorialDialogVisible,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tutorialDialogVisible) = $event)),
            modal: "",
            closeOnEscape: "",
            class: "tutorial_dialog",
            style: { width: 'min(90vw, 720px)' },
            dismissableMask: ""
          }, {
            header: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" ", -1)
            ]))]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("iframe", {
                  src: _ctx.tutorialVideoUrl,
                  title: "Tutoriel vidéo",
                  frameborder: "0",
                  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                  allowfullscreen: ""
                }, null, 8, _hoisted_7)
              ])
            ]),
            _: 1
          }, 8, ["visible"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isLoading"]))
}